import { createStore, persist } from '@repo/zustand';
export const usePrivacyConsentStore = createStore({
    name: 'PrivacyConsentStore',
})(persist((set) => ({
    consents: {},
    isOpen: false,
    setConsent: (id, value) => set((state) => ({ consents: { ...state.consents, [id]: value } })),
    setConsents: (consents) => set((state) => ({ consents: { ...state.consents, ...consents } })),
    resetConsents: () => set({ consents: {} }),
    openConsents: () => set({ isOpen: true }),
    closeConsents: () => set({ isOpen: false }),
}), {
    name: 'privacy-consent-storage-v1',
    partialize: (state) => ({ consents: state.consents }),
}));
